import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-svg-icon',
    templateUrl: './svg-icon.component.html',
    standalone: false
})
export class SvgIconComponent {
  @Input() public classStyle: string;
  @Input() public icon: string;

  public path = './../../assets/sprite/sprite.svg#';
}
